<template>
  <div
    class="logo"
    :class="extraItem.extras('logo.size')"
    :style="{
      height: pxOrVw(extraItem.extras('nav.model')),
      display: extraItem.extras('nav.display') == 1 ? 'flex' : 'none',
    }"
  >
    <img
      :src="extraItem.extras('logo.src')"
      :style="{
        display: extraItem.extras('logo.display') == 1 ? 'block' : 'none',
      }"
      alt=""
    />
  </div>
</template>
<script>
export default {
  name: "Logo",
  props: ["extras"],
  data() {
    return {};
  },
};
</script>
